<div class="d-flex justify-content-center align-items-center w-100 h-100">
    <div class="pl-0 col-xl-4 col-md-6 col-10" *ngIf="!this.reset&&!this.otp">
        <div class="card border-0 box-shadow rounded-0">
            <div class="card-header d-flex justify-content-center align-items-center border border-white bg-white mt-1">
               <h4>Forgot your password?</h4>
            </div>
            <div class="card-body text-center">
                <h5 class="text-primary">Enter your Email Address</h5>
              

                <form [formGroup]="form" class="text-left mt-4">
                    <div class="form-group">
                        <input [formControl]="email" class="form-control validation-field" placeholder="Email" type="text">                      
                        <small class="text-danger" *ngIf="form.get('email').touched && form.get('email').hasError('required')">Email is required</small>                              
                        <small class="text-danger" *ngIf="form.get('email').touched && form.get('email').hasError('email')">Invalid email address</small>
                    </div>
                   
                    <div class="form-group">
                        <button class="btn btn-block bg-primary text-white" type="submit" (click)="Reset()">Next</button>
                    </div>
                </form>
        </div>
    </div>
</div> 

    <div class="pl-0 col-xl-4 col-md-6 col-10"  *ngIf="this.reset && !this.otp">
        <div class="card border-0 box-shadow rounded-0">
            <div class="card-header d-flex justify-content-center align-items-center border border-white bg-white mt-1">
               <h4>Enter OTP sent to your email Address</h4>
            </div>
            <div class="card-body text-center">                
                    <input type="number"><br><br>
                   
                    <button class="btn btn-primary btn-block" (click)="Otp()" type="submit">Submit</button>  
               
        </div>
    </div>
</div> 



<div class="pl-0 col-xl-4 col-md-6 col-10"  *ngIf="this.otp">
    <div class="card border-0 box-shadow rounded-0">
        <div class="card-header d-flex justify-content-center align-items-center border border-white bg-white mt-1">
           <h4>Reset Your password</h4>
        </div>
        <div class="card-body text-center">
             <h5 class="text-primary">Enter New password</h5>
          
   <form [formGroup]="form" (ngSubmit)="onSubmit(form.value)">
       
                <div class="form-group">
                    <input [formControl]="password" class="form-control validation-field" placeholder="New Password" type="password" minlength="6">
                     <small class="text-danger" *ngIf="form.get('password').touched">
                        <span *ngIf="form.get('password').hasError('required')">Password is required</span>
                        <span *ngIf="form.get('password').hasError('minlength')">Password isn't long enough, minimum of 6 characters</span>
                    </small>                     
                </div>
                <div class="form-group">
                    <input [formControl]="confirmPassword" class="form-control validation-field" placeholder="Confirm Password" type="password">
                    <small class="text-danger" *ngIf="form.get('confirmPassword').touched">
                        <span *ngIf="form.get('confirmPassword').hasError('required')">Confirm Password is required</span>
                        <span *ngIf="form.get('confirmPassword').hasError('mismatchedPasswords')">Passwords do not match</span>
                    </small> 
                </div>
                <button class="btn btn-primary btn-block" (click)="Otp()" type="submit">Submit</button>  
            
            
            </form>
             
           
    </div>
</div>
</div> 
</div>